import React, { useEffect, useRef, useState } from "react";
import { Renderer } from "vexflow4";
import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';
import optionHandler from "./optionHandler";
import { Radio, Space } from 'antd-mobile'
import { RadioValue } from "antd-mobile/2x/es/components/radio";
import { Note } from "tonal";
import { doPostMessage } from "../../utils/rn";
import { formatHeXianOption, formatYinJieOption } from "../../utils/question";

const pt = console.log

const staveFormat = (notes: string[] | string[][], question_type: string) => {
    if (question_type !== 'SelectionYinJie') {
        const formatNotes = formatHeXianOption(notes);
        const accidentals: any[] = [];
        // 非选择音阶
        (formatNotes as string[]).forEach((v: string, i: number) => {
            const note = Note.get(v.replace('/', ''));
            if (note.acc) {
                accidentals.push({ index: i, modifier: note.acc });
            }
            if (v[1] === 'n') {
                accidentals.push({ index: i, modifier: 'n' });
            }
        })
        return [{
            keys: formatNotes,
            duration: "1",
            accidentals
        }]
    } else {
        const formatNotes = formatYinJieOption(notes);
        // 选择音阶题
        const data: { keys: string[]; accidentals: { index: number; modifier: string; }[]; duration: string; }[] = [];
        (formatNotes as string[][]).forEach((v: string[], i: number) => {
            v.forEach((item: string) => {
                const note = Note.get(item.replace('/', ''));
                const accidentals = note.acc ? [{ index: 0, modifier: note.acc }] : [];
                data.push({
                    keys: [item],
                    accidentals,
                    duration: "1"
                })
            });
        })
        return data;
    }
}


const Option = (
    { config, question_type, correctOpt, questionIndex, viewOnly, initChoose }:
        {
            config: { [key: string]: string[] | string[][] },
            question_type: string,
            correctOpt: string,
            initChoose: string,
            questionIndex: number,
            viewOnly: boolean,
        }
) => {
    const staveRef1 = useRef<HTMLCanvasElement>(null);
    const staveRef2 = useRef<HTMLCanvasElement>(null);
    const staveRef3 = useRef<HTMLCanvasElement>(null);
    const staveRef4 = useRef<HTMLCanvasElement>(null);

    const [chosen, setChosen] = useState<RadioValue>('')

    const initStave = () => {
        [staveRef1, staveRef2, staveRef3, staveRef4].forEach((staveRef, index: number) => {
            const render = new Renderer(staveRef.current ?? '', Renderer.Backends.CANVAS);
            render.resize(window.innerWidth * 0.85, window.innerHeight / 6);
            const handler = new optionHandler(render);

            let data: string[] | string[][] = []
            if (index === 0) data = config['A'];
            if (index === 1) data = config['B'];
            if (index === 2) data = config['C'];
            if (index === 3) data = config['D'];

            if (data) {
                handler.setStaveNotes(staveFormat(data, question_type));
            }
            handler.duration = 'w';
            handler.init();
        })
    };

    useEffect(() => {
        setChosen(initChoose);
    }, [])

    useEffect(() => {
        if (config) {
            initStave();
        }
    }, [config])

    useEffect(() => {
        doPostMessage(questionIndex, 'debug');
        setChosen(initChoose);
    }, [questionIndex, initChoose, viewOnly])

    const handler = (e: RadioValue) => {
        if (viewOnly) return;
        setChosen(e);
        doPostMessage({ isCorrect: e === correctOpt, choose: e }, 'answer_select');
    }

    return (
        <div className="options">
            <Radio.Group value={chosen} onChange={handler}>
                <div className={"option-container" + (chosen === 'A' ? ' option-chosen' : '')}>
                    <Radio value='A' style={radioStyle}>
                        <canvas ref={staveRef1} />
                    </Radio>
                </div>
                <div className={"option-container" + (chosen === 'B' ? ' option-chosen' : '')}>
                    <Radio value='B' style={radioStyle}>
                        <canvas ref={staveRef2} />
                    </Radio>
                </div>
                <div className={"option-container" + (chosen === 'C' ? ' option-chosen' : '')}>
                    <Radio value='C' style={radioStyle}>
                        <canvas ref={staveRef3} />
                    </Radio>
                </div>
                <div className={"option-container" + (chosen === 'D' ? ' option-chosen' : '')}>
                    <Radio value='D' style={radioStyle}>
                        <canvas ref={staveRef4} />
                    </Radio>
                </div>
            </Radio.Group>
        </div>

    );
};

export default Option

const radioStyle = {
    marginLeft: '5px',
    '--icon-size': '18px',
    '--font-size': '14px',
    '--gap': '6px',
}
